module.exports = __webpack_public_path__ + "img/card_3.a9299ffc.jpeg";